import React from "react";
import ReactDOM from "react-dom/client";
import "./index.css";
import App from "./App";
import reportWebVitals from "./reportWebVitals";
import {
  preloadResources,
  lazyLoadImages,
  triggerSEOEvents,
} from "./utils/seo";

const root = ReactDOM.createRoot(document.getElementById("root"));

// SEO 최적화 초기화
if (process.env.NODE_ENV === "production") {
  // 리소스 프리로드
  preloadResources();

  // 페이지 로드 완료 후 SEO 이벤트 트리거
  window.addEventListener("load", () => {
    triggerSEOEvents();
    lazyLoadImages();
  });
}

root.render(
  <React.StrictMode>
    <App />
  </React.StrictMode>
);

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();
